import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';

import { Grid, Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import { isArray, isEmpty, concat, includes } from 'lodash';

import { Table } from '~/components';
import { t } from '~/helpers';
import api from '~/services/api';

import * as S from './styles';

export default function TransferList({
  items,
  id,
  onCallback
}) {
  const [data, setData] = useState([]);
  const [left, setLeft] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLeft, setDataLeft] = useState([]);
  const [dataRight, setDataRight] = useState([]);
  const [clearLeft, setClearLeft] = useState(false);
  const [clearRight, setClearRight] = useState(false);

  const handleGetData = useCallback(async (value) => {
    setLoading(true);

    try {
      const response = await api.get(`itensperfis/${value}`);
      setLeft(response.data);
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }, []);

  const handleMoveToRight = useCallback(() => {
    setData((state) => concat(state, dataLeft));
    setLeft((state) => state.filter((s) => !includes(dataLeft.map((l) => l.modu_codigo), s.modu_codigo)));
    setDataLeft([]);
    setClearLeft(true);
  }, [dataLeft]);

  const handleMoveToLeft = useCallback(() => {
    setLeft((state) => concat(state, dataRight));
    setData((state) => state.filter((s) => !includes(dataRight.map((l) => l.modu_codigo), s.modu_codigo)));
    setDataRight([]);
    setClearRight(true);
  }, [dataRight]);

  useEffect(() => {
    if (!isEmpty(items)) setData(items);
  }, [items]);

  useEffect(() => {
    if (id) handleGetData(id);
  }, [id]);

  useEffect(() => {
    setClearLeft(false);
    setClearRight(false);
  }, [clearLeft, clearRight]);

  useEffect(() => {
    onCallback(data);
  }, [data]);

  return (
    <S.Warpper>
      <S.List>
        <S.WrapperList>
          <Table
            checkbox
            noButton
            cells={[
              { id: 'modu_nome', label: 'Nome' },
              { id: 'modu_posicaomenu', label: 'Posição' }
            ]}
            data={left}
            size="small"
            loading={loading}
            onCallback={(value) => setDataLeft(value)}
            clearCheckeds={clearLeft}
          />
        </S.WrapperList>
      </S.List>
      <S.List>
        <Grid container direction="column" alignItems="center">
          <Button
            variant="outlined"
            size="small"
            disabled={isEmpty(dataLeft)}
            onClick={() => handleMoveToRight()}
          >
            &gt;
          </Button>

          <Button
            variant="outlined"
            size="small"
            disabled={isEmpty(dataRight)}
            onClick={() => handleMoveToLeft()}
          >
            &lt;
          </Button>
        </Grid>
      </S.List>
      <S.List>
        <S.WrapperList secondary>
          <Table
              checkbox
              noButton
              cells={[
                { id: 'modu_nome', label: 'Nome' },
                { id: 'modu_posicaomenu', label: 'Posição' },
                {
                  id: 'iper_inclusao',
                  label: 'Incluir',
                  type: 'checkbox',
                  configure: { true: 1, false: 0 }
                },
                {
                  id: 'iper_exclusao',
                  label: 'Excluir',
                  type: 'checkbox',
                  configure: { true: 1, false: 0 }
                },
                {
                  id: 'iper_alteracao',
                  label: 'Alterar',
                  type: 'checkbox',
                  configure: { true: 1, false: 0 }
                },
                {
                  id: 'iper_consulta',
                  label: 'Pesquisar',
                  type: 'checkbox',
                  configure: { true: 1, false: 0 }
                }
              ]}
              data={data}
              size="small"
              onCallback={(value) => setDataRight(value)}
              clearCheckeds={clearRight}
              onCallbackChanged={(values) => setData(values)}
            />
        </S.WrapperList>
      </S.List>
    </S.Warpper>
  )
}

TransferList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  id: PropTypes.number.isRequired,
  onCallback: PropTypes.func.isRequired
}
